
(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npTabs', function () {
        return {
            restrict: 'E',
            controller: ['$scope', '$sce', '$timeout', 'pubSub', controller],
            controllerAs: 'vm',
            templateUrl: '/app/shared/tabs/npTabs.html',
            scope: {
                tabs: '=',
                tabWidth: '=',
                onClick: '&onClick',
                backgroundClass: '@',
                colorClass: '@',
                activeColorClass: '@',
                moduleClass: '@'
            },
            link: function (scope, element, attrs, ctrl, transclude) {
            }
        };
    });

    function controller($scope, $sce, $timeout, pubSub) {
        var vm = this;
        var onTabsChangeSetting = pubSub.subscribe('onTabsChangeSetting', onChange);
		var onActiveTab = pubSub.subscribe('onActiveTab', onActiveTab);

        vm.color = $scope.colorClass || 'color-white';
        vm.activeColor = $scope.activeColorClass || 'color-black';
        vm.initialize = initialize;

		$scope.$watchCollection('tabs', function (newValue) {
			vm.tabs = newValue;
		});

        vm.tabWidth = $scope.tabWidth;
		vm.onClick_ = function (tabIndex, event, tab) {
            if (tab.disabled) {
                event.stopPropagation();
                event.preventDefault();
                return;
            }
            ativeTabs(tab);
            $scope.onClick({ tabIndex: tabIndex, tab: tab });
            $timeout(_addActiveClassForIconAndTitle, 100);
        };

		function onActiveTab(tab) {
			_onActiveTab(tab);
			$timeout(_addActiveClassForIconAndTitle, 100);
		}

        function onChange(index, tab) {
            $timeout(function () {
                vm.tabs[index] = tab;
            });
        }

        function ativeTabs(tab) {
            angular.forEach(vm.tabs, function (item) {
                item.activated = false;
            });
            tab.activated = true;
            if (!tab.visible) {
                // if tab not visible at the first time page loaded then visible it
                tab.visible = true;
            }
		}

		function _onActiveTab(index) {
			angular.forEach(vm.tabs, function (item) {
                item.active = false;
                angular.element('#' + item.href).removeClass('active');
			});
			vm.tabs[index].active = true;
			angular.element('#np-tabs li').removeClass('active');
			angular.element('#np-tabs-parent-' + vm.tabs[index].href).addClass('active');
			angular.element('#' + vm.tabs[index].href).addClass('active');
		}

        function initialize() {
            if (vm.tabs != null && vm.tabs.length > 0) {
                vm.tabs.forEach(function (tab) {
                    if ((typeof tab.name === "string" || tab.name instanceof String)) {
                        tab.name = $sce.trustAsHtml(tab.name);
                    }
                });                
            }
        }

        function _addActiveClassForIconAndTitle() {
            $('#np-tabs li a tab-heading i').removeClass($scope.activeColorClass);
            $('#np-tabs li a tab-heading span').removeClass($scope.activeColorClass);

            $('#np-tabs li.active a tab-heading i').addClass($scope.activeColorClass);
            $('#np-tabs li.active a tab-heading span').addClass($scope.activeColorClass);
        }

        $scope.$on('$destroy', function () {
			onActiveTab();
        });
    }
})();